import { valueOf } from 'microstates';

export default class TextState {
  content = String;
  specialCharactersArray = Array;

  setText(text) {
    return this.content.set(text);
  }

  get specialCharacters() {
    return valueOf(this.specialCharactersArray);
  }
}
